import { Result } from "../_helpers/Helpers";
import * as auth from "../app/modules/Auth/_redux/authRedux";

export default function setupAxios(axios, store) {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  axios.defaults.withCredentials = true;

  // Request interceptor
  axios.interceptors.request.use(
    config => {
      const { auth: { authToken } } = store.getState();
      config.headers.Authorization = authToken;
      return config;
    },
    error => Promise.reject(error)
  );

  // Response interceptor
  axios.interceptors.response.use(
    response => {
      if (response.data.type === Result.Unauthenticated) store.dispatch(auth.actions.logout(window.location.pathname));
      if (response.headers["authorization"]) store.dispatch(auth.actions.setToken(response.headers["authorization"]));
      return response;
    },
    error => Promise.reject(error)
  );
}